// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-17rrze7-0"
})(["min-width:", ";max-width:", ";height:", ";"], _ref => {
  let {
    $size
  } = _ref;
  return $size;
}, _ref2 => {
  let {
    $size
  } = _ref2;
  return $size;
}, _ref3 => {
  let {
    $size
  } = _ref3;
  return $size;
});
const AlertFilled = _ref4 => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref4;
  return /*#__PURE__*/_jsxs(SVG, {
    ...props,
    $size: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation',
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, " ", /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM10.828 6.527l.188 7.562h1.968l.188-7.562h-2.344zm2.445 10.242c0-.688-.562-1.227-1.273-1.227-.71 0-1.273.54-1.273 1.227s.562 1.226 1.273 1.226c.71 0 1.273-.539 1.273-1.226z",
      children: " "
    })]
  });
};
AlertFilled.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,
  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,
  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default AlertFilled;